const parseDate = (value) => {
	if (!value) {
		return null;
	}

	const parsedDate = new Date(value);

	return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
};

const compareNullableDates = (left, right) => {
	if (left && right) {
		const diff = left.getTime() - right.getTime();
		if (diff !== 0) {
			return diff;
		}

		return 0;
	}

	if (left) {
		return -1;
	}

	if (right) {
		return 1;
	}

	return 0;
};

const getAddedDate = (batch) => {
	return parseDate(batch?.receivedAt) || parseDate(batch?.created);
};

const getStableBatchId = (batch) => {
	return String(batch?._id || batch?.id || '');
};

const compareStableBatchIds = (left, right) => {
	return getStableBatchId(left).localeCompare(getStableBatchId(right));
};

const compareKnownBatchesByFEFO = (left, right) => {
	const leftExpiry = parseDate(left?.expiryDate);
	const rightExpiry = parseDate(right?.expiryDate);
	const expiryDiff = compareNullableDates(leftExpiry, rightExpiry);
	if (expiryDiff !== 0) {
		return expiryDiff;
	}

	const addedDiff = compareNullableDates(getAddedDate(left), getAddedDate(right));
	if (addedDiff !== 0) {
		return addedDiff;
	}

	return compareStableBatchIds(left, right);
};

const compareBatchesByAddedDate = (left, right) => {
	const addedDiff = compareNullableDates(getAddedDate(left), getAddedDate(right));
	if (addedDiff !== 0) {
		return addedDiff;
	}

	return compareStableBatchIds(left, right);
};

const shouldInsertUnknownBeforeKnown = (unknownBatch, knownBatch) => {
	const addedDiff = compareNullableDates(getAddedDate(unknownBatch), getAddedDate(knownBatch));
	if (addedDiff !== 0) {
		return addedDiff < 0;
	}

	return compareStableBatchIds(unknownBatch, knownBatch) < 0;
};

export const sortWarehouseBatchesByPriority = (batches = []) => {
	const knownBatches = [];
	const unknownBatches = [];

	batches.forEach(batch => {
		if (parseDate(batch?.expiryDate)) {
			knownBatches.push(batch);
			return;
		}

		unknownBatches.push(batch);
	});

	const sortedKnownBatches = knownBatches.sort(compareKnownBatchesByFEFO);
	const sortedUnknownBatches = unknownBatches.sort(compareBatchesByAddedDate);

	if (!sortedKnownBatches.length) {
		return sortedUnknownBatches;
	}
	if (!sortedUnknownBatches.length) {
		return sortedKnownBatches;
	}

	const sortedBatches = [...sortedKnownBatches];

	sortedUnknownBatches.forEach(unknownBatch => {
		let insertionIndex = sortedBatches.length;

		for (let i = 0; i < sortedBatches.length; i += 1) {
			const candidateBatch = sortedBatches[i];
			if (!parseDate(candidateBatch?.expiryDate)) {
				continue;
			}

			if (shouldInsertUnknownBeforeKnown(unknownBatch, candidateBatch)) {
				insertionIndex = i;
				break;
			}
		}

		// Known batches remain FEFO; unknown batches are inserted by batch added order.
		sortedBatches.splice(insertionIndex, 0, unknownBatch);
	});

	return sortedBatches;
};
